module.exports = __webpack_public_path__ + "img/image4.415c0865.png";